import { store } from '@betacrew/jars-flux'
export const componentKey = "IMPORT_DATA_GRID_VIEW";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        updateImportGridRecords: (state, action) => {
            state.importGridRecords = {
                ...state.importGridRecords,
                ...action.payload,
            }
        },
        setGridViewPayerList: (state, action) => {
            state.gridViewPayerList = action.payload;
        },
        setGridViewBoxOptionsList: (state, action) => {
            state.gridViewBoxOptionsList = action.payload;
        },
        setFileOnlyForStateFlag: (state, action) => {
            state.fileOnlyForStateFlag = action.payload;
        },
        setgridViewBoxSelected: (state, action) => {
            state.gridViewBoxSelected = action.payload;
        },
        setGridRecordsSelected: (state, action) => {
            state.gridRecordsSelected = action.payload;
        },
        updatePaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setErrorPayerIds: (state, action) => {
            state.errorPayerIds = action.payload;
        },
        setReloadGridRecords: (state, action) => {
            state.reloadGridRecords = action.payload;
        },
        setIsFinalFormSubmittedSuccessfully: (state, action) => {
            state.isFinalFormSubmittedSuccessfully = action.payload;
        }, 
        setSaveImportFormSuccessData: (state, action) => {
            state.saveImportFormSuccessData = action.payload;
        }, 
        setEditPayerData: (state, action) => {
            state.editPayerData = action.payload;
        }, 
        setPayerUpdationSuccessful: (state, action) => {
            state.payerUpdationSuccessful = action.payload;
        }, 
        setClickedRecipientData: (state, action) => {
            state.clickedRecipientData = action.payload;
        }, 
        setRecipientEditSuccessfull: (state, action) => {
            state.recipientEditSuccessfull = action.payload;
        },
        setIsSubmitBtnDisabled: (state, action) => {
            state.isSubmitBtnDisabled = action.payload;
        },
        setSubmittedRecordsHasErrors: (state, action) => {
            state.submittedRecordsHasErrors = action.payload;
        },
        setReloadFormGridPageFieldsData: (state, action) => {
            state.reloadFormGridPageFieldsData = action.payload;
        },
    }, 
    initialReducerState: {
        loadingState: false,
        importGridRecords: {
            totalRecords: 0,
            isAllSelected: false,
            records: [],
            totalAmount: 0,
            hasErrors: false,
            pageTotalAmount: 0,
            hasRecipientWithoutTIN: false,
        },
        gridViewPayerList: [],
        gridViewBoxOptionsList: [],
        fileOnlyForStateFlag: false,
        gridViewBoxSelected: null,
        gridRecordsSelected: [],
        paginationState: {
            page: 1,
            pageSize: 10,
            skip: 0,
            sorts: [],
            group: "Payer-asc",
            filters: [],
            gridFilter: "",
            payerId: "",
            jsonPreferences: [],
            jsonPreferencesGroup: [],
        },
        errorPayerIds: {},
        reloadGridRecords: false,
        isFinalFormSubmittedSuccessfully: false,
        saveImportFormSuccessData: null,
        editPayerData: null,
        payerUpdationSuccessful: false,
        clickedRecipientData: null,
        recipientEditSuccessfull: false,
        isSubmitBtnDisabled: false,
        submittedRecordsHasErrors: false,
        reloadFormGridPageFieldsData: false,
    }
});
export const {
    setLoadingState,
    updateImportGridRecords,
    setGridViewPayerList,
    setGridViewBoxOptionsList,
    setFileOnlyForStateFlag,
    setgridViewBoxSelected,
    setGridRecordsSelected,
    updatePaginationState,
    setErrorPayerIds,
    setReloadGridRecords,
    setIsFinalFormSubmittedSuccessfully,
    setSaveImportFormSuccessData,
    setEditPayerData,
    setPayerUpdationSuccessful,
    setClickedRecipientData,
    setRecipientEditSuccessfull,
    setIsSubmitBtnDisabled,
    setSubmittedRecordsHasErrors,
    setReloadFormGridPageFieldsData,
} = actions;